import React from "react";
import { SubTitle, Content } from "@/components/pages/Community";
import { Stack } from "@mui/material";
import styles from "./WhereToStart.module.scss";

const WhereToStart = ({ whereToStart }) => (
  <Stack
    gap={4}
    direction={{ xs: "column", md: "row" }}
    alignItems="flex-start"
    justifyContent="stretch"
    useFlexGap
    flexWrap="nowrap"
    className={styles.wrapper}
  >
    <Stack
      spacing={4}
      justifyContent="flex-start"
      width={{ xs: "100%", md: "calc(54% - 16px)" }}
    >
      <SubTitle sx={{ fontSize: "25px", fontWeight: "bold" }}>
        {whereToStart.title}
      </SubTitle>
      <Content sx={{ color: "white" }}>{whereToStart.description}</Content>
    </Stack>
    <Stack
      justifyContent="flex-start"
      width={{ xs: "100%", md: "calc(46% - 16px)" }}
      useFlexGap
      flexWrap="nowrap"
      gap={0.25}
    >
      {whereToStart.options.map(({ text, url }) => (
        <a className={styles.optionLink} href={url} key={text}>
          <span>{text}</span>
          <span>
            <i className="fa-solid fa-chevron-right" />
          </span>
        </a>
      ))}
    </Stack>
  </Stack>
);

export default WhereToStart;
